
<h1>Please check that the information is correct before booking.</h1>

<button class="btn btn-success btn-block btn-lg"
        (click)="ok()"
>
  <fa-icon *ngIf="loading" [icon]="faSpinner" spin="true"></fa-icon>
  Book
</button>
